import { createPortal } from 'react-dom'

import './index.css'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { NotificationState, ThemeState } from 'shared/stores'
import { HTML_Notification_Props } from 'shared/hooks/useNotification'
import { Notification } from '@office/ui-kit'

interface Notification_Object_Props extends HTML_Notification_Props {
  id: number
}

export default function NotificationFeature() {
  const notifications = useSelector(
    (state: NotificationState) => state.notifications.NOTIFICATIONS,
  )
  const [notificationList, setNotificationList] = useState([])
  const theme = useSelector((state: ThemeState) => state.theme.THEME)

  useEffect(() => {
    setNotificationList(notifications)
  }, [notifications])

  function Notification_Window() {
    return (
      <div className="notification-bar" data-theme={theme}>
        {notificationList.map((notification: Notification_Object_Props) => {
          return (
            <Notification
              type={notification.type}
              title={notification.title}
              text={notification.text}
              key={notification.id}
            />
          )
        })}
      </div>
    )
  }

  // eslint-disable-next-line
  return createPortal(<Notification_Window />, document.body)
}
